export default function TiltifyCallback() {
    return (
        <div>
            <h1>Redirecting...</h1>
        </div>
    )
}